<div>
  <div class="prev-bar">
    <a (click)="back()" style="color: #0064c1" class="btn new-btn btn-secondary"><i class="fas fa-arrow-left"></i> {{ 'claimSection.generalLabels.generalButtonLabels.back' | translate}} </a>
  </div>
  <div class="col-12">
    <h5>{{ 'ecClaim.occupationalDisease.title' | translate }}</h5>
    <p>{{ 'ecClaim.occupationalDisease.subHeading' | translate }}</p>
  </div>
  <br/>
  <div class="row col-12">
    <div class="col-lg-9 col-md-12">
      <form [formGroup]="occupationalDiseaseForm">
        <div class="form-group">
          <qnect-ui #EC_DISEASE_HOSPITAL_NAME [fieldId]="'EC_DISEASE_HOSPITAL_NAME'" [formGroup]="occupationalDiseaseForm" name="hospitalName" [maxLength]="60"></qnect-ui>
        </div>
        <div class="form-group">
          <qnect-ui #EC_DISEASE_COMMENCEMENTDATE [fieldId]="'EC_DISEASE_COMMENCEMENTDATE'" [formGroup]="occupationalDiseaseForm" name="commencementDate"></qnect-ui>
        </div>
        <div class="form-group">
          <qnect-ui #EC_DISEASE_SUFFERING [fieldId]="'EC_DISEASE_SUFFERING'" [formGroup]="occupationalDiseaseForm" name="suffering"></qnect-ui>
        </div>
        <div class="form-group">
          <qnect-ui #EC_DISEASE_TYPE_OF_WORK [fieldId]="'EC_DISEASE_TYPE_OF_WORK'" [formGroup]="occupationalDiseaseForm" name="workType"></qnect-ui>
        </div>
        <div class="form-group">
          <qnect-ui #EC_DISEASE_RESULT [fieldId]="'EC_DISEASE_RESULT'" [formGroup]="occupationalDiseaseForm" name="result"></qnect-ui>
        </div>
        <div class="form-group" *ngIf="this.occupationalDisease.getResult()?.toLowerCase() == 'temporary incapacity'">
          <qnect-ui #EC_DISEASE_TEMPORARYDATE [fieldId]="'EC_DISEASE_TEMPORARYDATE'" [formGroup]="occupationalDiseaseForm" name="temporaryDate"></qnect-ui>
        </div>
        <div class="form-group" *ngIf="this.occupationalDisease.getResult()?.toLowerCase() == 'permanent incapacity'">
          <qnect-ui #EC_DISEASE_PERMANENTDATE [fieldId]="'EC_DISEASE_PERMANENTDATE'" [formGroup]="occupationalDiseaseForm" name="permanentDate"></qnect-ui>
        </div>
        <ng-container *ngIf="this.occupationalDisease.getResult()?.toLowerCase() == 'death'">
          <div class="form-group">
            <qnect-ui #EC_DISEASE_DEATHDATE [fieldId]="'EC_DISEASE_DEATHDATE'" [formGroup]="occupationalDiseaseForm" name="deathDate"></qnect-ui>
          </div>

          <app-fatal-case #fatalCase> </app-fatal-case>

        </ng-container>
      </form>
    </div>
    <div class="col-lg-3 col-xl-3 col-md-12">
      &nbsp;
    </div>
  </div>
  <div class="submit-bar">
    <abandon-button></abandon-button>
    <a href="javascript:;" (click)="showModal()" class="Tertiary"> {{ 'claimSection.generalLabels.generalButtonLabels.save' | translate}}</a>
    <button (click)="goToNext()" class="btn btn-primary float-right new-btn">&nbsp;{{ 'claimSection.generalLabels.generalButtonLabels.next' | translate}}&nbsp;<i class="fas fa-arrow-right"></i></button>
  </div>
  <app-save-box [showTotalBox]="showTotalBox" (childEvent)="getData($event)"></app-save-box>
</div>
